// src/auth/AuthService.js
import { getAuth, signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { app } from '../firebaseConfig'; // Importa a instância do app Firebase

const auth = getAuth(app); // Inicializa o serviço de autenticação

export const loginUser = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    // userCredential.user contém o objeto do usuário logado
    console.log("Usuário logado com sucesso:", userCredential.user);
    return userCredential.user;
  } catch (error) {
    console.error("Erro no login:", error.message);
    throw error; // Lança o erro para ser tratado no componente de login
  }
};

export const logoutUser = async () => {
  try {
    await signOut(auth);
    console.log("Usuário deslogado com sucesso.");
  } catch (error) {
    console.error("Erro ao deslogar:", error.message);
    throw error;
  }
};

export { auth }; // Exporta a instância de auth para uso no AuthContext (onAuthStateChanged)